import { Note } from '../types/notes';

export const filterNotes = (weekDayNumber: number, notes: Note[]) =>
  notes.filter((note) => note.days.includes(weekDayNumber));
